<template>
  <!-- プルダウン選択肢 ここから-->
  <div class="dropdown dropup" :class="question.question.class">
    <b-dropdown
      id="dropdown-dropup"
      dropup
      variant="primary"
      style="width: 100%; margin: auto"
    >
      <template v-slot:button-content>
        <div class="list-btn" v-if="option[selected]">
          <div class="item">
            <div class="boxes">{{ circleNum[selected] }}</div>
            <div class="options">{{ option[selected] }}</div>
          </div>
        </div>
        <div class="list-btn" v-else>
          <div class="item">
            <div class="options">{{ circleNum[selected] }}</div>
          </div>
        </div>
      </template>
      <b-dropdown-item
        v-for="(q, idx) in option"
        class="dropdown-items"
        :key="`opt${idx}`"
        @click="
          () => {
            if (!modal && !sent) {
              selected = idx;
            }
          }
        "
      >
        <div class="item"  v-if="q">
          <div class="boxes">{{ circleNum[idx] }}</div>
          <div class="options">{{ q }}</div>
        </div>
        <div v-else>
          <div class="options only-number">{{ circleNum[idx] }}</div>
        </div>
      </b-dropdown-item>
    </b-dropdown>

    <p class="answer" v-if="sent || modal">
      <img v-if="tof" src="@/assets/img/maru.png" />
      <img v-else src="@/assets/img/batsu.png" />
      正答：{{circleNum[this.answerIndexInOrder]}} {{ answer }}
    </p>
  </div>
</template>

<script>
/* eslint-disable no-console */
import CircleNum from "@/tools/circleNum";
import randomizer from "@/tools/randomizer";

export default {
  data() {
    return {
      selected: null
    };
  },
  mounted() {
    console.log(this.option);
    if (!this.optionOrder) {
      if (this.question.question.random) {
        this.$store.commit(
          "setOptionOrder",
          randomizer(this.question.question.option.map((e, idx) => idx))
        );
      } else {
        this.$store.commit(
          "setOptionOrder",
          this.question.question.option.map((e, idx) => idx)
        );
      }
    }

    if (Number.isSafeInteger(this.response) && this.sent) {
      this.selected = this.optionOrder.findIndex(e => e === this.response);
    }
  },
  computed: {
    circleNum() {
      return CircleNum;
    },
    response() {
      return this.$store.getters.response;
    },
    sent() {
      return this.$store.getters.sent || this.$store.state.modal;
    },
    modal() {
      return this.$store.state.modal;
    },
    option() {
      return this.$store.getters.option;
    },
    optionOrder() {
      return this.$store.getters.optionOrder;
    },
    question() {
      return this.$store.getters.question;
    },
    answerIndex() {
      if (Array.isArray(this.$store.getters.answer)) {
        return this.$store.getters.answer[0];
      }
      return this.$store.getters.answer;
    },
    answer() {
      return this.question.question.option[this.answerIndex];
    },
    answerIndexInOrder() {
      return this.optionOrder.findIndex(e => e === this.answerIndex);
    },
    tof() {
      return this.optionOrder[this.selected] === this.answerIndex;
    }
  },
  watch: {
    selected(nv) {
      if (!this.sent) {
        this.$store.commit("setResponse", {
          response: this.optionOrder[nv],
          correct: this.tof
        });
      }
    }
  }
};
</script>

<style scoped>
.list-btn {
  display: inline-block;
  width: calc(100% - 1em);
}

.item,
.answer-list li {
  display: flex;
}

.item div.boxes,
.answer-list li div.boxes {
  text-align: left;
}

.order-list li div.boxes,
.multi-list li div.boxes {
  flex: 0 0 6em;
}

.item div.options,
.answer-list li div.options {
  flex: 1 0 auto;
  padding-left: 0.5em;
}

.only-number {
  text-align: center;
}
</style>